<template>
  <div v-if="latestAiResponse" class="space-y-4">
    <OriginalMessageSection
      :original-message="latestAiResponse.originalMessage"
    />

    <AgentResponseSection
      :agent-answer="latestAiResponse.agentAnswer ?? latestAiResponse.answer_nl"
      @translation-result="handleTranslationResult"
    />

    <ResponseToSendSection
      :translation="latestAiResponse.translation"
      :local-translation-result="localTranslationResult"
    />

    <div v-if="latestAiResponse.additionalInfo" class="space-y-3">
      <BicycleDetailsSection
        :bicycle-details="latestAiResponse.additionalInfo.bicycle_details"
      />

      <RelatedArticlesSection
        :articles="latestAiResponse.additionalInfo.related_articles"
      />

      <SuggestionsSection
        :suggestions="latestAiResponse.additionalInfo.suggestions"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { AiResponseData } from '@/stores/messages';
import ResponseToSendSection from '@/components/ai-response/ResponseToSendSection.vue';
import AgentResponseSection from '@/components/ai-response/AgentResponseSection.vue';
import OriginalMessageSection from '@/components/ai-response/OriginalMessageSection.vue';
import BicycleDetailsSection from '@/components/ai-response/BicycleDetailsSection.vue';
import RelatedArticlesSection from '@/components/ai-response/RelatedArticlesSection.vue';
import SuggestionsSection from '@/components/ai-response/SuggestionsSection.vue';

interface Props {
  latestAiResponse?: AiResponseData | null;
}

defineProps<Props>();

// Local translation state for this specific AI response
const localTranslationResult = ref<string | undefined>(undefined);

// Handle translation result from AgentResponseSection
const handleTranslationResult = (result: string) => {
  localTranslationResult.value = result;
};
</script>
